<template>
  <v-theme-provider :dark="dark">
    <div
      v-if="businessInfo"
    >
      <base-img
        :src="require('@/assets/wordmark.png')"
        contain
        max-width="128"
        min-height="78"
        width="100%"
      />

      <base-title
        size="body-1"
        space="4"
        :title="businessInfo.fields.title"
        weight="regular"
      />

      <base-body class="subtitle">
        <rich-text-renderer :document="businessInfo.fields.subtitle" />
      </base-body>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseInfo',

    props: {
      dark: Boolean,
    },

    data () {
      return {
        businessInfo: null,
      }
    },

    async mounted () {
      const { items } = await this.$contentful.getEntries({
        content_type: 'businessInfo',
        select: 'fields',
      })
      const [entry] = items
      this.businessInfo = entry
    },
  }
</script>

<style lang="scss" scoped>
.subtitle p {
  margin-bottom: 0;
}
</style>
